var $ = require('jquery');
$(function (e) {
    var tv = $("#topvideo_container"),
        isMobile = require('./mobile-test').isMobile();

    if (tv.length == 0) {
        return;
    }

    $(window).bind('scroll', function () {
        if (isMobile) {
            return;
        }
        if ($("#topvideo").width() > 480) {
            var offset = $(document).scrollTop(),
                offset2 = $("#endvideodiv").position();

            if ((offset > offset2.top) && (!tv.hasClass("small"))) {
                $("#fakevideo").height($("#topvideo_container").height());
                tv.addClass("small");
            }
            if ((offset < offset2.top) && (tv.hasClass("small"))) {
                $("#fakevideo").height(0);
                tv.removeClass("small");
            }
        } else {
            $("#fakevideo").height(0);
            tv.removeClass("small");
        }
    });
});